import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { WorkGroup } from "@app/models/rest/work-group";

@Injectable({
  providedIn: "root"
})
export class GroupRestService extends HateoasResourceOperation<WorkGroup> {
  constructor() {
    super(WorkGroup);
  }
}
